// extracted by mini-css-extract-plugin
export default {"shipping_header":"ShippingReturnPolicy_shipping_header__YwccL","shipping_Sub_header":"ShippingReturnPolicy_shipping_Sub_header__xDsKo"};